import { observer } from "mobx-react-lite";
import { PlatformIconKind } from "@/domains/api/types";
import { useResolvePlatformIconData } from "@/components/icons/utils/resolve-platform-icon";
import { MDSIcon } from "@/mds";

interface PlatformIconProps {
  iconKind: PlatformIconKind;
  className?: string;
}

/**
 * @deprecated - Use the newer MDS components instead.
 *
 * - If something doesn't exist yet, please create a new MDS component and
 *   have it reviewed by the team!
 *
 * - If something needs to hook into our `stores`, add it to the /components directory.
 *
 * - If something is a one-off; please colocate it with the component/page that
 *   needs it.
 *
 * - If you have questions, please ask in the #hub-eng-web-team Slack channel.
 */
export const PlatformIcon = observer<PlatformIconProps>(({ iconKind, className }) => {
  const data = useResolvePlatformIconData({ iconKind });

  if (!data) {
    return null;
  }

  if (data.icon) {
    return <MDSIcon kind={data.icon} className={className} />;
  }

  if (data.image) {
    const imgClassName = className as string | undefined;

    return <img src={data.image} className={imgClassName} />;
  }

  return null;
});
